import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e546241a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { name: "staking-complete" };
const _hoisted_2 = { class: "desc" };
const _hoisted_3 = { class: "crypto-stake" };
const _hoisted_4 = { class: "crypto-stake-is" };
const _hoisted_5 = { class: "plan" };
const _hoisted_6 = { class: "crypto-stake-is" };
const _hoisted_7 = { class: "crypto-stake-is" };
const _hoisted_8 = { class: "quantity" };
const _hoisted_9 = { class: "crypto-stake-is" };
const _hoisted_10 = { class: "interest-rate" };
import { useMessage } from '@/const/messages';
import CryptoIcon from '@/materials/atoms/CryptoIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        term: null,
        interestRate: null,
        amount: null,
        cryptoName: null,
        interestAmount: null
    },
    emits: ["onButtonClick"],
    setup(__props, { emit }) {
        const props = __props;
        const FREE_PLAN = 1;
        const { STAKECONFIRM, STAKECOMPLETE, PLANCARD, format } = useMessage();
        const onButtonClick = () => {
            emit('onButtonClick');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(format)(_unref(STAKECOMPLETE).DONE)), 1),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(CryptoIcon, {
                        class: "crypto_icon",
                        base: props.cryptoName.toLowerCase(),
                        width: 50
                    }, null, 8, ["base"]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).PLAN)), 1),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(props.term === FREE_PLAN ? _unref(format)(_unref(PLANCARD).PLAN) : props.term + _unref(format)(_unref(STAKECONFIRM).DAY)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).RATE)), 1),
                        _createElementVNode("div", null, _toDisplayString(props.interestRate) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).QUANTITY)), 1),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(props.amount) + " " + _toDisplayString(props.cryptoName.toUpperCase()), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).INTEREST)), 1),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(props.interestAmount) + " " + _toDisplayString(props.cryptoName.toUpperCase()), 1)
                        ])
                    ]),
                    _createElementVNode("button", {
                        onClick: onButtonClick,
                        class: "act-btn"
                    }, _toDisplayString(_unref(format)(_unref(STAKECOMPLETE).BTN)), 1)
                ])
            ]));
        };
    }
});
